import { HorizontalAlignment } from '../../shared.enums';
import { Island } from '../island.class';

export const isRightOverlapCfn = (island: Island): boolean => {
	// Use island connections to determins if this is a right overlap island
	const frontPanelId = island.frontPanel.id;
	const connection = island.connections.children.find((c) => c.sourcePanelId === frontPanelId && c.horizontalAlign === HorizontalAlignment.right) ?? null;
	return connection !== null;
};
